import { render, staticRenderFns } from "./Ranking2.vue?vue&type=template&id=a3a5e504"
import script from "./Ranking2.vue?vue&type=script&lang=js"
export * from "./Ranking2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports